<template>
    <div :class="editing ? 'border border-gray-300 bg-gray-warm-50 rounded-md px-6 py-5' : 'border-b border-gray-200 pb-5'">
        <h2 class="text-gray-400 text-lg font-semibold">
            Signers
        </h2>

        <div v-if="editing">
            <p v-if="! recipients_proxy.length"
                class="text-base text-gray-500 mb-3"
            >
                Specify one or more individuals who must sign the documents in this Envelope
            </p>

            <div v-else class="pt-3">
                <div v-for="(recipient, index) in recipients_proxy"
                    :key="recipient.id"
                    class="flex items-start pt-1 pb-3 pl-8"
                >
                    <envelope-recipient
                        :index="index"
                        :recipient="recipient"
                    />

                    <div v-if="recipient.completed_at"
                        class="flex-none w-8"
                    ></div>

                    <div v-else
                        class="cursor-pointer flex flex-none justify-end hover:text-red-600 items-center text-gray-400 w-8 mt-1 pt-10"
                        @click="removeRecipient(recipient)"
                    >
                        <i class="fas fa-minus-circle"></i>
                    </div>
                </div>
            </div>
        </div>

        <div v-else
            class="mt-1"
        >
            <div v-for="recipient in recipients_proxy"
                class="flex-1 flex justify-between pl-8 pt-1.5"
            >
                <div class="flex items-center">
                    <div class="text-md font-semibold"
                        :class="recipient.completed_at ? 'text-blue-600' : 'text-black'"
                    >
                        <i class="text-sm fas fa-user mb-2 mr-1"
                            :class="recipient.completed_at ? 'text-blue-400' : 'text-gray-300'"
                        />

                        {{ recipient.name }}
                    </div>

                    <div class="text-md mx-2 text-gray-400">
                        /
                    </div>

                    <div class="text-md"
                        :class="recipient.completed_at ? 'text-blue-600' : 'text-black'"
                    >
                        <i class="text-sm fas fa-envelope mb-2 mr-1"
                            :class="recipient.completed_at ? 'text-blue-400' : 'text-gray-300'"
                        />

                        {{ recipient.email }}
                    </div>
                </div>

                <div v-if="recipient.completed_at"
                    class="text-sm text-blue-600 pl-8"
                >
                    Signed on <span class="font-bold">{{ formatDate(recipient.completed_at) }}</span>
                    at <span class="font-bold">{{ formatTime(recipient.completed_at) }}</span>
                </div>
            </div>
        </div>

        <div v-if="editing"
            class="w-full flex justify-end"
        >
            <button type="button"
                class="flex flex-none py-1 text-blue-600 hover:text-blue-800 cursor-pointer leading-none items-end outline-none"
                @click="addRecipient"
            >
                <div class="text-md font-semibold leading-none text-label">
                    <span class="text-lg mr-0.5 pt-1.5">+</span>

                    {{ recipients_proxy.length ? $t('Add another signer') : $t('Add a signer') }}
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import EnvelopeRecipient from './envelope-recipient.vue';

export default {
    components: {
        EnvelopeRecipient,
    },

    props: {
        value: { default: () => [] },
        editing: { default: false },
        statuses: { default: () => [] },
    },

    data() {
        return {
            recipients_proxy: [],
        }
    },

    computed: {
        has_recipients() {
            return !! this.recipients_proxy.filter(recipient => recipient.name || recipient.email).length;
        },
        recipients_are_valid() {
            return this.has_recipients
                && this.recipients_proxy.every(recipient => recipient.name && this.emailIsValid(recipient.email));
        },
    },

    methods: {
        addRecipient() {
            this.recipients_proxy.push({
                id: this.generateRandomId(),
                name: null,
                email: null,
            })
        },
        removeRecipient(recipient_to_remove) {
            this.recipients_proxy.splice(
                this.recipients_proxy.findIndex(recipient => recipient.id == recipient_to_remove.id), 1
            );
        },
        generateRandomId() {
            return Math.floor(Math.random() * (9999999 - 1) + 1);
        },
        formatDate(timestamp) {
            return timestamp ? dayjs(timestamp).format('M/D/YYYY') : null;
        },
        formatTime(timestamp) {
            return timestamp ? dayjs(timestamp).format('h:mm A') : null;
        },
        updateRecipientStatuses(statuses) {
            statuses.forEach(status => {
                let recipient_index = this.recipients_proxy.findIndex(proxy => proxy.id === status.id);

                if (recipient_index > -1) {
                    this.recipients_proxy[recipient_index].status = status.status;
                    this.recipients_proxy[recipient_index].sent_at = status.sent_at;
                    this.recipients_proxy[recipient_index].completed_at = status.completed_at;
                }
            });
        },
    },

    created() {
        this.recipients_proxy = this.value;
        this.updateRecipientStatuses(this.statuses);
    },

    watch: {
        recipients_proxy: {
            deep: true,
            handler(value) {
                this.$emit('input', value);
            },
        },
        statuses: {
            deep: true,
            handler(value) {
                this.updateRecipientStatuses(value);
            },
        },
    },
}
</script>
